// @flow

export const TRANSLATIONS_LOADING = 'TRANSLATIONS_LOADING'
export const TRANSLATIONS_LOADED = 'TRANSLATIONS_LOADED'
